import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import Realisations from "@/components/Realisations";
import Manifesto from "@/components/Manifesto";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import ScrollCroc from "@/components/ScrollCroc";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="bg-flytab-black text-flytab-cream antialiased" data-testid="flytab-app">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <Realisations />
        <Manifesto />
        <Contact />
      </main>
      <Footer />
      <ScrollCroc />
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#0A0A0A",
            border: "1px solid #3CE882",
            color: "#F4F4F0",
            fontFamily: "'JetBrains Mono', monospace",
            borderRadius: "9999px",
          },
        }}
      />
    </div>
  );
}

export default App;
